var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 204,
    viewBox: "0 0 50 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-42.5986 102.154C-42.4738 103.873 -41.792 105.495 -40.6659 106.726L9.84653 161.532C-1.59302 169.276 -14.9641 172.981 -28.4252 172.137C-41.8862 171.293 -54.7749 165.941 -65.316 156.819L-71.6132 151.156L-71.6132 190.287L-70.2999 191.091C-57.1001 198.964 -42.3607 203.309 -27.3039 203.766C-12.2471 204.224 2.69327 200.78 16.2785 193.721L16.6826 193.502C22.8525 190.221 28.6782 186.228 34.0589 181.591C38.8125 177.144 43.3109 172.385 47.5288 167.342C48.6935 165.988 49.3413 164.206 49.3413 162.354C49.3413 160.503 48.6935 158.72 47.5288 157.367L-4.09359 101.901L47.5289 46.4348C48.6935 45.0815 49.3413 43.299 49.3413 41.4475C49.3413 39.5959 48.6935 37.8134 47.5288 36.4601C43.3109 31.4166 38.8125 26.6579 34.0588 22.2106C28.6782 17.574 22.8525 13.5806 16.6826 10.2995L16.2785 10.0803C2.69327 3.02133 -12.2472 -0.422132 -27.3039 0.0353683C-42.3607 0.492869 -57.1001 4.83815 -70.2999 12.7109L-71.6132 13.5148L-71.6132 52.6461L-65.316 46.9829C-54.7749 37.8605 -41.8862 32.5087 -28.4252 31.6646C-14.9641 30.8205 -1.59301 34.5256 9.84653 42.2696L-40.6659 97.0754C-41.792 98.3071 -42.4738 99.9289 -42.5986 101.648L-42.6191 101.648C-42.6184 101.732 -42.6163 101.817 -42.6129 101.901C-42.6163 101.985 -42.6184 102.069 -42.6191 102.154L-42.5986 102.154Z",
    fill: "#FFBC78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW);
export default __webpack_public_path__ + "static/media/w.7c1537db9ea6c0b0761c5e7fd15947d0.svg";
export { ForwardRef as ReactComponent };